import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  text,
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      const element = document.getElementById('oferta');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={handleClick} className={`${`${`${`${`${`w-full md:w-auto bg-brand-yellow hover:bg-brand-yellowHover text-black font-bold py-4 px-8 rounded-full shadow-[0_4px_14px_0_rgba(251,191,36,0.39)] transition-colors duration-200 text-lg md:text-xl flex items-center justify-center gap-2 ${className}`} text-[16px] font-[700]`} text-[16px]`} text-[16px]`} text-[16px]`} text-[16px]`} data-id="element-91">
      {text}
    </motion.button>;
}